export default function WhatsAppButton() {
  const phone = "554797740084";
  const message = encodeURIComponent("Olá! Gostaria de um orçamento.");

  return (
    <a
      href={`https://wa.me/${phone}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 right-5 z-[9999] bg-[#25D366] hover:bg-[#1ebe5d] text-white w-14 h-14 rounded-full flex items-center justify-center shadow-lg transition-all"
    >
      <i className="ri-whatsapp-line text-2xl"></i>
    </a>
  );
}